import Login from '../views/auth/Login'
import Register from '../views/auth/Register'
import ForgotPassword from '../views/auth/ForgotPassword'
import RecoverPassword from '../views/auth/RecoverPassword'

export default [
  {
    name: 'login',
    path: '/connexion',
    component: Login
  },
  {
    name: 'register',
    path: '/inscription',
    component: Register
  },
  {
    name: 'forgotpassword',
    path: '/recuperation-de-mot-de-passe',
    component: ForgotPassword
  },
  {
    name: 'recoverpassword',
    path: '/changement-de-mot-de-passe',
    component: RecoverPassword
  }
]
